import React, { useState } from 'react';
import { authApi } from '../../services/api';
import { Button } from '../common/Button';

interface LoginFormProps {
  onSuccess: (user: { id: number; username: string }) => void;
}

export const LoginForm: React.FC<LoginFormProps> = ({ onSuccess }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      setLoading(true);
      setError(null);
      const res = await authApi.login(username, password);
      onSuccess(res.user);
    } catch (err: any) {
      setError(err?.response?.data?.error || 'Napaka pri prijavi');
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="pnevmatika-form" style={{ maxWidth: 420, margin: '40px auto' }}>
      <h2>Prijava</h2>
      {error && <div className="error-message" style={{ marginBottom: 12 }}>{error}</div>}
      <div className="form-group">
        <label htmlFor="username">Uporabniško ime</label>
        <input id="username" value={username} onChange={(e) => setUsername(e.target.value)} disabled={loading} />
      </div>
      <div className="form-group">
        <label htmlFor="password">Geslo</label>
        <input id="password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} disabled={loading} />
      </div>
      <Button type="submit" disabled={loading}>{loading ? 'Prijavljam...' : 'Prijava'}</Button>
    </form>
  );
};
